/** Product vs organization branding for logged-in users. */

export const organizationBrandName = (user, fallback = 'Workloop') => {
  if (user?.globalOrganization) return fallback;
  const name = String(user?.organizationName || '').trim();
  return name || fallback;
};

export const workloopInboxLabel = (user, channel) => {
  const stored = String(channel?.name || '').trim();
  if (stored && stored.toLowerCase() !== 'workloop') return stored;
  return organizationBrandName(user);
};

export const workloopInboxInitial = (label) => {
  const letter = String(label || 'W').trim().charAt(0);
  return (letter || 'W').toUpperCase();
};
